import React from 'react';
import './AppSurface.css';

interface AppSectionHeroProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
  aside?: React.ReactNode;
  className?: string;
}

interface AppStatCardProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  caption?: React.ReactNode;
  tone?: 'default' | 'blue' | 'mint';
  className?: string;
}

interface AppToolbarProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

interface AppEmptyStateProps {
  icon: React.ReactNode;
  title: string;
  message?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const AppSectionHero: React.FC<AppSectionHeroProps> = ({
  icon,
  title,
  subtitle,
  aside,
  className = '',
}) => (
  <section className={`app-surface-hero ${className}`.trim()}>
    <div className="app-surface-hero-main">
      <span className="app-surface-hero-icon">{icon}</span>
      <div className="app-surface-hero-copy">
        <h1 className="app-surface-hero-title">{title}</h1>
        {subtitle ? <div className="app-surface-hero-subtitle">{subtitle}</div> : null}
      </div>
    </div>
    {aside ? <div className="app-surface-hero-aside">{aside}</div> : null}
  </section>
);

export const AppStatCard: React.FC<AppStatCardProps> = ({
  icon,
  label,
  value,
  caption,
  tone = 'default',
  className = '',
}) => (
  <article className={`app-surface-stat tone-${tone} ${className}`.trim()}>
    <div className="app-surface-stat-row">
      <span className="app-surface-stat-icon">{icon}</span>
      <div>
        <span className="app-surface-stat-label">{label}</span>
        <span className="app-surface-stat-value">{value}</span>
        {caption ? <span className="app-surface-stat-caption">{caption}</span> : null}
      </div>
    </div>
  </article>
);

export const AppToolbar: React.FC<AppToolbarProps> = ({ left, right, className = '' }) => (
  <section className={`app-surface-toolbar ${className}`.trim()}>
    <div className="app-surface-toolbar-left">{left}</div>
    <div className="app-surface-toolbar-right">{right}</div>
  </section>
);

export const AppEmptyState: React.FC<AppEmptyStateProps> = ({
  icon,
  title,
  message,
  action,
  className = '',
}) => (
  <section className={`app-surface-empty ${className}`.trim()} aria-live="polite">
    <span className="app-surface-empty-icon">{icon}</span>
    <div className="app-surface-empty-copy">
      <h2>{title}</h2>
      {message ? <p>{message}</p> : null}
    </div>
    {action ? <div className="app-surface-empty-action">{action}</div> : null}
  </section>
);
